{
  "generic": {
    "no": "No",
    "yes": "Sí",
    "text": "Texto "
  },
  "consent": {
    "defaultLabelText": "Al enviar este formulario, acepta nuestra ",
    "defaultLabelLink": "política de privacidad"
  },
  "text": {
    "defaultHeadlineText": "Este es un titular",
    "defaultText": "Este es un bloque de texto",
    "floatingDefaultText": "¡NUEVO!"
  },
  "button": {
    "submitDefaultText": "Enviar",
    "instagramDefaultText": "Síguenos",
    "defaultText": "Haz clic aquí",
    "closing": "CERRANDO..."
  },
  "input": {
    "emailLabel": "Correo electrónico",
    "emailPlaceholder": "Introduce tu correo electrónico",
    "passwordLabel": "Contraseña",
    "passwordPlaceholder": "Introduce la contraseña",
    "nameLabel": "Nombre",
    "namePlaceholder": "Introduce tu nombre",
    "firstNameLabel": "Nombre",
    "firstNamePlaceholder": "Introduce el nombre",
    "lastNameLabel": "Apellido",
    "lastNamePlaceholder": "Introduce el apellido",
    "phoneLabel": "Teléfono",
    "phonePlaceholder": "Introduce el número de teléfono",
    "textareaLabel": "Mensaje",
    "textareaPlaceholder": "Introduce tu mensaje",
    "regularLabel": "Texto",
    "regularPlaceholder": "Introduce texto",
    "defaultLabel": "Etiqueta",
    "defaultPlaceholder": "Marcador de posición",
    "datePlaceholder": "Selecciona fecha",
    "stepLabel": "Introduce tu pregunta aquí"
  },
  "dropdown": {
    "placeholder": "Selecciona una opción",
    "firstItem": "Opción 1",
    "secondItem": "Opción 2",
    "chooseCountry": "País"
  },
  "buttonList": {
    "firstItem": "Opción 1",
    "secondItem": "Opción 2",
    "option1": "Elección 1",
    "option2": "Elección 2",
    "option3": "Elección 3",
    "subscriptionItem1": "Boletín",
    "subscriptionItem2": "Actualizaciones",
    "chooseSubscriptionTopics": "Elige temas de suscripción",
    "other": "Otro",
    "uncheck-all-label": "No deseo recibir ninguno de estos correos electrónicos"
  },
  "rating": {
    "rateLabel": "Califícanos",
    "npsLabel": "¿Qué probabilidad hay de que nos recomiendes?",
    "veryUnsatisfied": "Muy insatisfecho",
    "unsatisfied": "Insatisfecho",
    "neutral": "Neutral",
    "satisfied": "Satisfecho",
    "loveIt": "¡Me encanta!",
    "minValueLabel": "Bajo",
    "maxValueLabel": "Alto",
    "minValueLabelNps": "Poco probable",
    "maxValueLabelNps": "Muy probable"
  },
  "deadline": {
    "days": "Días",
    "hours": "Horas",
    "minutes": "Minutos",
    "seconds": "Segundos"
  },
  "bulletList": {
    "firstItem": "Beneficio 1",
    "secondItem": "Beneficio 2"
  },
  "discountCode": {
    "copyMessage": "¡Copiado al portapapeles!",
    "fallback": "WELCOME10",
    "textDefault": "Tu código de descuento",
    "buttonDefault": "Copiar"
  },
  "share": {
    "buttonText": "Compartir"
  },
  "common": {
    "label": "Etiqueta"
  },
  "wcag": {
    "banner": "Banner promocional",
    "closeButton": "Cerrar",
    "submitButton": "Enviar formulario"
  },
  "spinTheWheel": {
    "prizeWonText": "¡Felicidades!",
    "prizeWonButtonText": "Reclama tu premio",
    "prizeLostText": "¡Ahhh, qué lástima! :-(",
    "prizeLostButtonText": "Haz clic para cerrar",
    "spinButtonLabel": "GIRAR"
  },
  "memory": {
    "resultWonText": "¡Buen trabajo! Tu tiempo fue {elapsedTime}",
    "resultWonButtonText": "Reclama tu premio"
  },
  "stepNavigation": {
    "nextButtonText": "Siguiente",
    "previousButtonText": "Atrás",
    "lastButtonText": "Cerrar",
    "submitButtonText": "Enviar"
  },
  "defaultRealTimeMessage": {
    "validationError": "Por favor, revise el formato de los datos enviados.",
    "unknownError": "Se produjo un problema inesperado al enviar.",
    "conflictError": "Este usuario ya existe.",
    "success": "Formulario enviado."
  }
}
